/*
 *
 * Recover Password
 *
 */

import "./styles.scss";

import { API, Endpoints } from "utils/api";
import { Input, notification } from "antd";
import { setLoader, setToken, setUser } from "store/actions";

import { Footer } from "screens";
import { Helmet } from "react-helmet";
import { Icons } from "components";
import Password from "components/Password";
import React from "react";
import Strings from "utils/strings";
import { connect } from "react-redux";
import { push } from "connected-react-router";

export class RecoverPassword extends React.Component<any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			email: "",
			password: "",
			showPassword: false,
            isPasswordValid: false,

			isMobile: window.innerWidth <= 768
		};

		this.handleResize = this.handleResize.bind(this);
		window.addEventListener("resize", this.handleResize);
	}

	componentDidMount() {
		this.handleResize();
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.handleResize);
	}

	handleResize() {
		this.setState({ isMobile: window.innerWidth <= 768 });
	}

	async recoverPassword() {
		const { email } = this.state;
		const { dispatch, isPsychologist } = this.props;

		dispatch(setLoader(true));

		let response: any;
		try {
			const body = {
				email
			};

			response = await API.post({
				url: isPsychologist ? Endpoints.uriPsychologistsRecoverPassword() : Endpoints.uriUsersRecoverPassword(),
				data: body
			});

			if (response.ok) {
				this.setState({ email: "" });

				notification.success({
					message: Strings.authentication.header,
					description: Strings.authentication.emailSent,
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.authentication.header,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.authentication.header,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	async definePassword() {
		const { password } = this.state;
		const { dispatch, match, isPsychologist } = this.props;
		const { email, code } = match?.params || {};

		dispatch(setLoader(true));

		let response: any;
		try {
			const body = {
				email,
				password
			};

			response = await API.post({
				url: isPsychologist
					? Endpoints.uriPsychologistsRecoverPassword(code)
					: Endpoints.uriUsersRecoverPassword(code),
				data: body
			});

			if (response.ok) {
				const { user, psychologist, token } = response.data.results || {};

				if (isPsychologist) {
					dispatch(setUser(psychologist));
				} else {
					dispatch(setUser(user));
				}
				dispatch(setToken(token));

				notification.success({
					message: Strings.authentication.header,
					description: Strings.authentication.passwordChanged,
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.authentication.header,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.authentication.header,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	render() {
		const { email, password, showPassword, isPasswordValid } = this.state;
		const { dispatch, match, mobile } = this.props;
		const { email: forwardEmail, code } = match?.params || {};

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.authentication.recoverPassword} | Team24</title>
					<meta name="description" content="Description of Recover Password" />
				</Helmet>
				<div className="RecoverPasswordContent">
					<div className="RecoverPasswordWrapper">
						<div className="LoginBox">
							<div className="LoginWelcome" />
							<div className="LoginWrapper">
								<div className="LoginBackground" />
								<div className="LoginForm">
									<h1>{Strings.authentication.recoverPassword}</h1>
									<form
										onSubmit={(e: any) => {
											e.preventDefault();

											if (!forwardEmail && !code) {
												this.recoverPassword();
											} else {
												this.definePassword();
											}
										}}
									>
										{!forwardEmail && !code ? (
											<React.Fragment>
												<h3>{Strings.authentication.insertEmailPassword}</h3>
												<Input
													placeholder={Strings.placeholders.email}
													className="LoginInputClass"
													value={email}
													type="email"
													required
													prefix={<Icons.Message smaller />}
													onChange={(e: any) => this.setState({ email: e.target.value })}
												/>
												<div className="LoginOptions">
													<a
														href="/confirm-account"
														onClick={(e: any) => {
															e.preventDefault();
															dispatch(push("/login"));
														}}
														className="LoginOptionLink --no-decoration"
													>
														<span>{Strings.authentication.registerFooter}</span>
													</a>
												</div>
											</React.Fragment>
										) : (
											<React.Fragment>
												<h3>{Strings.authentication.definePassword2}</h3>
												<Password
													className="LoginInputClass"
													password={password}
													showPassword={showPassword}
													placeholder={Strings.authentication.password}
													onPasswordChange={(newPassword: string, isValid: boolean) => {
														this.setState({
															password: newPassword,
															isPasswordValid: isValid
														});
													}}
													onShowPasswordChange={(value: boolean) =>
														this.setState({ showPassword: value })
													}
												/>
											</React.Fragment>
										)}
										<button type="submit" className="LoginButtonClass" disabled={!email && !isPasswordValid}>
											{!forwardEmail && !code
												? Strings.authentication.recover
												: Strings.generic.confirm}
										</button>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
				{mobile && <Footer />}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	user: state.user,
	mobile: state.mobile
});

export default connect(mapStateToProps)(RecoverPassword);
